import { chatHistoryBGColor } from 'globals/colors';

import { awayImage } from 'globals/assets';

const styles = {
  container: {
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: chatHistoryBGColor,
  },
  scrollContainer: {
    flex: '1 1 auto',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  messagesContainer: {
    padding: '5px 16px 25px',
  },
};

export const afterHoursStyles = offhoursImageUrl => {
  return {
    flex: '1 1 auto',
    overflowY: 'auto',
    overflowX: 'hidden',
    backgroundPosition: 'center 33.333%',
    backgroundImage: `url("${offhoursImageUrl || awayImage}")`,
    backgroundRepeat: 'no-repeat',
  };
};

export default styles;
